import {
  actionLoading,
  actionSuccess,
  actionErrored,
  actionReset,
} from 'api/helpers';
import { unAuthRequest, authRequest } from 'api/helpers';
import URL, { getDynamicEndpoint } from 'api/endpoints';

// Fetch user teams
export const FETCH_USER_TEAMS = 'FETCH_USER_TEAMS';

export const fetchUserTeamsLoading = actionLoading(FETCH_USER_TEAMS);
export const fetchUserTeamsSuccess = actionSuccess(FETCH_USER_TEAMS);
export const fetchUserTeamsErrored = actionErrored(FETCH_USER_TEAMS);

export const fetchUserTeams = () => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint().user_teams,
      fetchUserTeamsLoading,
      fetchUserTeamsSuccess,
      fetchUserTeamsErrored
    );
};

// Re-Fetch user teams
export const REFETCH_USER_TEAMS = 'REFETCH_USER_TEAMS';

export const refetchUserTeamsLoading = actionLoading(REFETCH_USER_TEAMS);
export const refetchUserTeamsSuccess = actionSuccess(REFETCH_USER_TEAMS);
export const refetchUserTeamsErrored = actionErrored(REFETCH_USER_TEAMS);

export const refetchUserTeams = () => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint().user_teams,
      refetchUserTeamsLoading,
      refetchUserTeamsSuccess,
      refetchUserTeamsErrored
    );
};

// API for creating team within user's org
export const ADD_TEAM = 'ADD_TEAM';

export const addTeamLoading = actionLoading(ADD_TEAM);
export const addTeamSuccess = actionSuccess(ADD_TEAM);
export const addTeamErrored = actionErrored(ADD_TEAM);
export const addTeamReset = actionReset(ADD_TEAM);

export const addTeam = (data) => {
  return (dispatch) =>
    authRequest.post(
      dispatch,
      data,
      getDynamicEndpoint().add_team,
      addTeamLoading,
      addTeamSuccess,
      addTeamErrored
    );
};

export const resetAddTeamState = () => {
  return function (dispatch) {
    dispatch(addTeamReset());
  };
};

// API for sending invite to user for specific team
export const SEND_USER_INVITE_TEAM = 'SEND_USER_INVITE_TEAM';

export const sendUserInviteTeamLoading = actionLoading(SEND_USER_INVITE_TEAM);
export const sendUserInviteTeamSuccess = actionSuccess(SEND_USER_INVITE_TEAM);
export const sendUserInviteTeamErrored = actionErrored(SEND_USER_INVITE_TEAM);
export const sendUserInviteTeamReset = actionReset(SEND_USER_INVITE_TEAM);

export const sendUserInviteTeam = (teamUUID, data) => {
  return (dispatch) =>
    authRequest.post(
      dispatch,
      data,
      URL.send_invite_user + `${teamUUID}/invite`,
      sendUserInviteTeamLoading,
      sendUserInviteTeamSuccess,
      sendUserInviteTeamErrored
    );
};

export const resetSendUserInviteTeamState = () => {
  return function (dispatch) {
    dispatch(sendUserInviteTeamReset());
  };
};

// API for delete team
export const DELETE_TEAM = 'DELETE_TEAM';

export const deleteTeamAPILoading = actionLoading(DELETE_TEAM);
export const deleteTeamAPISuccess = actionSuccess(DELETE_TEAM);
export const deleteTeamAPIErrored = actionErrored(DELETE_TEAM);
export const deletTeamAPIReset = actionReset(DELETE_TEAM);

export const deleteTeam = (teamId) => {
  return (dispatch) =>
    authRequest.delete(
      dispatch,
      URL.delete_team + `/${teamId}`,
      deleteTeamAPILoading,
      deleteTeamAPISuccess,
      deleteTeamAPIErrored
    );
};

export const resetDeleteTeamState = () => {
  return function (dispatch) {
    dispatch(deletTeamAPIReset());
  };
};

// API for cancel invite
export const DELETE_INVITE = 'DELETE_INVITE';

export const deleteInviteLoading = actionLoading(DELETE_INVITE);
export const deleteInviteSuccess = actionSuccess(DELETE_INVITE);
export const deleteInviteErrored = actionErrored(DELETE_INVITE);
export const deleteInviteReset = actionReset(DELETE_INVITE);

export const deleteInvite = (uuid) => {
  return (dispatch) =>
    authRequest.delete(
      dispatch,
      URL.cancel_invite_user + `${uuid}`,
      deleteInviteLoading,
      deleteInviteSuccess,
      deleteInviteErrored
    );
};

export const resetDeleteInviteState = () => {
  return function (dispatch) {
    dispatch(deleteInviteReset());
  };
};

// Re-send invite to user
export const RESEND_INVITE = 'RESEND_INVITE';

export const resendInviteLoading = actionLoading(RESEND_INVITE);
export const resendInviteSuccess = actionSuccess(RESEND_INVITE);
export const resendInviteErrored = actionErrored(RESEND_INVITE);
export const resendInviteReset = actionReset(RESEND_INVITE);

export const resendInvite = (uuid) => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint(uuid).resend_invite_user,
      resendInviteLoading,
      resendInviteSuccess,
      resendInviteErrored
    );
};

export const resetResendInviteState = () => {
  return function (dispatch) {
    dispatch(resendInviteReset());
  };
};
